<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenz · Digitale Prozesse</p>

      <h2 class="presentation-page__title">Digitale Prozesse mit RETIS</h2>

      <p class="presentation-page__text">
        Cloud-basiertes Multi-Mandanten-System für End-to-End-Projektsteuerung und Banken-taugliche
        Dokumentation.
      </p>

      <div class="presentation-page__body presentation-page__body--split">
        <div class="presentation-page__column presentation-page__column--text">
          <h3 class="presentation-page__section-heading">Plattform-Features</h3>
          <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

          <div class="presentation-page__features">
            <article
              v-for="feature in features"
              :key="feature.heading"
              class="presentation-page__feature"
            >
              <div class="presentation-page__feature-icon" aria-hidden="true">
                <i :class="['fa', feature.icon]"></i>
              </div>
              <div>
                <h4 class="presentation-page__feature-heading">{{ feature.heading }}</h4>
                <p class="presentation-page__feature-text">{{ feature.text }}</p>
              </div>
            </article>
          </div>
        </div>

        <div class="presentation-page__column presentation-page__column--stats">
          <h3 class="presentation-page__section-heading">Was das in Zahlen heißt</h3>
          <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

          <div class="presentation-page__stat-grid">
            <div
              v-for="(row, rowIndex) in statRows"
              :key="rowIndex"
              class="presentation-page__stat-grid-row"
            >
              <article
                v-for="stat in row"
                :key="stat.label"
                :class="[
                  'presentation-page__stat-card',
                  'presentation-page__stat-card--compact',
                  `presentation-page__stat-card--${stat.accent}`,
                ]"
              >
                <p class="presentation-page__stat-value">{{ stat.value }}</p>
                <p class="presentation-page__stat-label">{{ stat.label }}</p>
                <p class="presentation-page__stat-detail">{{ stat.detail }}</p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage20',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  computed: {
    statRows() {
      return [this.stats.slice(0, 2), this.stats.slice(2, 4)];
    },
  },

  data() {
    return {
      features: [
        {
          icon: 'fa-cloud',
          heading: 'Cloudbasiert',
          text:
            'Multi-Mandanten- und Multi-Projekt-Management. Zugriff von überall, Rollen- und Rechtekonzept.',
        },
        {
          icon: 'fa-refresh',
          heading: 'End-to-End-Digitalisierung',
          text:
            'Von Lead bis Inbetriebnahme — kein Medienbruch, kein Excel-Chaos, keine verlorenen E-Mails.',
        },
        {
          icon: 'fa-mobile',
          heading: 'Desktop & mobile App',
          text: 'Monteure dokumentieren vor Ort, Büro sieht Status in Echtzeit. iOS und Android.',
        },
        {
          icon: 'fa-line-chart',
          heading: 'Transparente Projektsteuerung',
          text:
            'KPIs, Fortschritt, Soll/Ist je Projekt — Dashboards für Geschäftsführung und Kunden.',
        },
        {
          icon: 'fa-file-text-o',
          heading: 'Banken- und prüftaugliche Abnahmen',
          text: 'Vollständige Foto- und Messprotokolle nach RAL, DIN, VDE — direkt exportierbar.',
        },
      ],
      stats: [
        {
          accent: 'brand-primary',
          value: '0',
          label: 'Medienbrüche',
          detail: 'Lead → Abnahme volldigital',
        },
        {
          accent: 'brand-teal',
          value: '100%',
          label: 'Dokumentation',
          detail: 'Foto-, Mess- und Prüfprotokolle',
        },
        {
          accent: 'brand-primary',
          value: '24/7',
          label: 'Monitoring',
          detail: 'Anlagenstatus & Ertrag in Echtzeit',
        },
        {
          accent: 'brand-primary',
          value: '1',
          label: 'Plattform',
          detail: 'Für alle Beteiligten — keine Insellösungen',
        },
      ],
    };
  },
};
</script>
